module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_j_normal.55fb203b.png";